
export default function customTable () {
	return {
		restrict: 'E',
		scope: {
			headers: '=',
			data: '=',
			active: '=',
			search: '&', 
			showIfEmpty:'=',
			previousSearch:'='
		},
		template: require('./custom-table.html'),
		transclude: true,
		controller: 'CustomTableController',
		controllerAs: 'customTable',
		bindToController: true,
	}
};

customTable.$inject = [];



// WEBPACK FOOTER //
// ./src/directive/custom-table/custom-table.js